var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCharging(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.62535 5.0155C2.7196 5.0155 1.98535 5.74976 1.98535 6.6555V13.3755C1.98535 14.2812 2.71961 15.0155 3.62535 15.0155H15.0726C15.9784 15.0155 16.7126 14.2812 16.7126 13.3755V6.6555C16.7126 5.74976 15.9784 5.0155 15.0726 5.0155H3.62535ZM4.03353 5.84884C3.35422 5.84884 2.80353 6.39953 2.80353 7.07884V12.8764C2.80353 13.5557 3.35422 14.1064 4.03353 14.1064H14.7075C15.3868 14.1064 15.9375 13.5557 15.9375 12.8764V7.07884C15.9375 6.39953 15.3868 5.84884 14.7075 5.84884H4.03353Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.349 8.75037C18.349 8.2985 18.7153 7.93219 19.1672 7.93219C19.619 7.93219 19.9854 8.2985 19.9854 8.75037V11.2807C19.9854 11.7325 19.619 12.0989 19.1672 12.0989C18.7153 12.0989 18.349 11.7325 18.349 11.2807V8.75037Z",
    fill: "#333333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9053 10.4674C14.3223 10.697 14.2329 11.1276 13.6967 11.0415C12.4754 10.8405 11.0961 10.5604 9.91362 10.3525C9.91362 10.9296 9.91362 11.5869 9.91362 12.1611C9.91362 12.563 9.7051 12.6491 9.37742 12.4769C7.64969 11.5008 5.95399 10.4805 4.22626 9.56186C3.87215 9.38468 3.90618 8.92054 4.34318 9.00328C5.50493 9.20423 6.98976 9.47841 8.09652 9.66667C8.09652 9.09274 8.09652 8.45784 8.09652 7.85498C8.09652 7.48179 8.30504 7.36696 8.6625 7.56791C10.3902 8.51525 12.1477 9.54872 13.9053 10.4674Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCharging);
export default __webpack_public_path__ + "static/media/charging.7131b04a43e07d5d3f45e43eff19db47.svg";
export { ForwardRef as ReactComponent };